import React,{useEffect,useState} from 'react'
import getUsers from '../data-source/users'
const UsersContext = React.createContext([])

export const UsersProvider = ({children,errorHandler = () => {}}) => {
    const [users,setUsers] = useState([])

    useEffect( () => {
        getUsers()
        .then( setUsers )
        .catch( errorHandler )
    }, [errorHandler])

    return <UsersContext.Provider value={users}>{children}</UsersContext.Provider>

}
export const UsersConsumer = UsersContext.Consumer
export default UsersContext